import Vue from 'vue'
import VueUploadMultipleImage from 'vue-upload-multiple-image';
Vue.component('vue-upload-multiple-image', VueUploadMultipleImage);
import { forEach, findIndex, orderBy, cloneDeep } from 'lodash'
const Base = Vue.options.components["vue-upload-multiple-image"];
const BlinkiUpload = Base.extend({
  methods:{
    editImage (file) {
      if (this.disabled) return
      let reader = new FileReader()
      let formData = new FormData()
      formData.append('file', file)
      reader.onload = (e) => {
        let dataURI = e.target.result
        if (dataURI) {
          if (this.images.length && this.images[this.currentIndexImage]) {
            this.images[this.currentIndexImage].path = dataURI
            this.images[this.currentIndexImage].name = file.name
            this.$emit('edit-image', formData, this.currentIndexImage, this.images)
          }
        }
      }
      reader.readAsDataURL(file)
    },
    markIsPrimary (currentIndex) {
      this.images.map((item, index) => {
        if (currentIndex === index) {
          item.highlight = 1
          item.default = 1
        } else {
          item.highlight = 0
          item.default = 0
        }
        return item
      })
      this.currentIndexImage = 0
      this.images = orderBy(this.images, 'default', 'desc')
      this.$emit('mark-is-primary', this.currentIndexImage, this.images)

    },
  }
});
Vue.component('blinkiUpload', BlinkiUpload);
